module.exports = __webpack_public_path__ + "static/media/used15.527c1425.JPG";